import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast } from '@repo/ui';
import { api } from '@xtnd/web/shared/api';

/**
 * Mutation for saving Juniper configuration
 */
export function useSaveJuniperConfigMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Partial<any>) => {
      // Use JWT-based Juniper config endpoint that extracts tenant ID from token
      return await api.patch('/juniper/config', data);
    },
    onSuccess: () => {
      showToast.success('Configuration saved successfully!');
      queryClient.invalidateQueries({ queryKey: ['juniper-config'] });
      queryClient.invalidateQueries({ queryKey: ['tenant-config'] });
    },
    onError: (error: any) => {
      showToast.error(
        error?.response?.data?.message || error?.message || 'Failed to save configuration'
      );
    },
  });
}

